/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CategoryDto } from './categoryDto';
import { PlaceInformationDto } from './placeInformationDto';
import { LocationInfoDto } from './locationInfoDto';


export interface CompanyV2Dto { 
    id?: number;
    uuid?: string;
    companyName?: string;
    companyNo?: string;
    vat?: string;
    logo?: string;
    phone1?: string;
    phone2?: string;
    email?: string;
    contactFirstName?: string;
    contactLastName?: string;
    hqLocation?: LocationInfoDto;
    category?: CategoryDto;
    placeInformation?: PlaceInformationDto;
}

